export default __webpack_public_path__ + "static/media/appScreen2.179138bf.png";